import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/products/radioguide/webp/reinvox-receiver-r-300.webp")